import { HttpClient } from '@shared/adapters/HttpClient';
import type { UploadCourierWeightFileRequest, UploadCourierWeightFileResponse } from '../models';

const ALLOWED_EXTENSIONS = ['.xlsx', '.xls'];
const MAX_FILE_BYTES = 10 * 1024 * 1024;

export class CourierWeightFilesApiAdapter {
  constructor(private readonly httpClient: HttpClient) {}

  async uploadCourierWeightFile(data: UploadCourierWeightFileRequest): Promise<UploadCourierWeightFileResponse> {
    const extension = data.file.name.includes('.')
      ? data.file.name.slice(data.file.name.lastIndexOf('.')).toLowerCase()
      : '';

    if (!ALLOWED_EXTENSIONS.includes(extension)) {
      throw new Error('INVALID_FILE_TYPE');
    }

    if (data.file.size > MAX_FILE_BYTES) {
      throw new Error('FILE_TOO_LARGE');
    }

    const formData = new FormData();
    formData.append('courier_id', String(data.courier_id));
    formData.append('file', data.file);

    return this.httpClient.postMultipart<UploadCourierWeightFileResponse>('/courier-weight-files', formData);
  }
}
